import { render } from "./withdraw-detail.vue?vue&type=template&id=b3c79e9a&scoped=true"
import script from "./withdraw-detail.vue?vue&type=script&lang=js"
export * from "./withdraw-detail.vue?vue&type=script&lang=js"

import "./withdraw-detail.vue?vue&type=style&index=0&id=b3c79e9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c79e9a"]])

export default __exports__